import { useController } from "react-hook-form";

import { FILTER } from "@/constants";
import { useI18n } from "@/contexts/i18nContext";
import { Slider } from "@components/Field";
import Typography from "@components/Typography";

import styles from "./MinimumReach.module.css";

const STEP_DEAFULT = 1_000;
const MIN_REACH_DEFAULT = 0;
const MAX_REACH_DEFAULT = 1_000_000;

const MinimumReach = ({
  min = MIN_REACH_DEFAULT,
  max = MAX_REACH_DEFAULT,
  step = STEP_DEAFULT,
}: {
  min?: number;
  max?: number;
  step?: number;
}) => {
  const { abbreviateNumber } = useI18n();
  const {
    field: { value, onChange },
  } = useController({
    name: FILTER.MIN_REACH,
  });
  return (
    <div className={styles.root}>
      <Typography variant="subtitle-1">
        {L.MENTIONS_VIEW_TOOLBAR_FILTER_MIN_REACH_THRESHOLD_PLACEHOLDER}
      </Typography>
      <Slider
        min={min}
        max={max}
        step={step}
        data-testid="filter-bar--min-reach-threshold-input"
        value={value || 0}
        onChange={onChange}
      />
      <div className={styles.minMax}>
        <Typography variant="caption">{min}</Typography>
        <Typography variant="caption">{abbreviateNumber(max)}</Typography>
      </div>
      <Typography>
        {L.MENTIONS_VIEW_TOOLBAR_FILTER_MIN_REACH_HELP}{" "}
        <a rel="noreferrer" target="_blank" href={L.HELP_ARTICLE_REACH}>
          {L.MENTIONS_VIEW_TOOLBAR_FILTER_MIN_REACH_HELP_LINK_TEXT}
        </a>
      </Typography>
    </div>
  );
};

export default MinimumReach;
